import { updateCallIsTranscriptHelpfulDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateCallIsTranscriptHelpfulCallable = getCallable(
  updateCallIsTranscriptHelpfulDefinition,
);
